import { fetchRequest } from "../../request/request";

export const loadSettings = async () => {
  return fetchRequest("/user/profile", null, "get");
};

export const saveSettings = async (data) => {
  await fetchRequest("/user/profile/", data, "post");
};
